export const strings = {
  editLinkHoverText: 'Edit',
  changePeriodStatusLinkHoverText: 'Change Status',
  addNewPeriodNodeText: 'Add new period',
  addNewGroupNodeText: 'Add new group',
  addNewEntityNodeText: 'Add new entity',
  addNewProjectNodeText: 'Add new project',
};